import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import CustomerPerformance from "../../../containers/modules/chart/customer-performance";

export default function CustomerPerformanceRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="customer-performance"
      index
      element={
        <AccessControl
          name={"Customer Performance Show"}
          auth={authUser}
          component={() => <CustomerPerformance />}
        />
      }
    ></Route>
  );
}
